"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRequestAdEntityToJSON = exports.BaseRequestAdEntityFromJSONTyped = exports.BaseRequestAdEntityFromJSON = exports.instanceOfBaseRequestAdEntity = void 0;
var runtime_1 = require("../runtime");
var AdAssets_1 = require("./AdAssets");
var AdSurvey_1 = require("./AdSurvey");
var AdThirdPartyTracking_1 = require("./AdThirdPartyTracking");
var SlotPositionsInner_1 = require("./SlotPositionsInner");
/**
 * Check if a given object implements the BaseRequestAdEntity interface.
 */
function instanceOfBaseRequestAdEntity(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBaseRequestAdEntity = instanceOfBaseRequestAdEntity;
function BaseRequestAdEntityFromJSON(json) {
    return BaseRequestAdEntityFromJSONTyped(json, false);
}
exports.BaseRequestAdEntityFromJSON = BaseRequestAdEntityFromJSON;
function BaseRequestAdEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'advertiserName': !(0, runtime_1.exists)(json, 'advertiser_name') ? undefined : json['advertiser_name'],
        'assets': !(0, runtime_1.exists)(json, 'assets') ? undefined : (0, AdAssets_1.AdAssetsFromJSON)(json['assets']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'tagline': !(0, runtime_1.exists)(json, 'tagline') ? undefined : json['tagline'],
        'thirdPartyTracking': !(0, runtime_1.exists)(json, 'third_party_tracking') ? undefined : (json['third_party_tracking'].map(AdThirdPartyTracking_1.AdThirdPartyTrackingFromJSON)),
        'survey': !(0, runtime_1.exists)(json, 'survey') ? undefined : (0, AdSurvey_1.AdSurveyFromJSON)(json['survey']),
        'slotPositions': !(0, runtime_1.exists)(json, 'slot_positions') ? undefined : (json['slot_positions'].map(SlotPositionsInner_1.SlotPositionsInnerFromJSON)),
        'notaryMetadata': !(0, runtime_1.exists)(json, 'notary_metadata') ? undefined : json['notary_metadata'],
        'dvClientCode': !(0, runtime_1.exists)(json, 'dv_client_code') ? undefined : json['dv_client_code'],
    };
}
exports.BaseRequestAdEntityFromJSONTyped = BaseRequestAdEntityFromJSONTyped;
function BaseRequestAdEntityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'advertiser_name': value.advertiserName,
        'assets': (0, AdAssets_1.AdAssetsToJSON)(value.assets),
        'name': value.name,
        'tagline': value.tagline,
        'third_party_tracking': value.thirdPartyTracking === undefined ? undefined : (value.thirdPartyTracking.map(AdThirdPartyTracking_1.AdThirdPartyTrackingToJSON)),
        'survey': (0, AdSurvey_1.AdSurveyToJSON)(value.survey),
        'slot_positions': value.slotPositions === undefined ? undefined : (value.slotPositions.map(SlotPositionsInner_1.SlotPositionsInnerToJSON)),
        'notary_metadata': value.notaryMetadata,
        'dv_client_code': value.dvClientCode,
    };
}
exports.BaseRequestAdEntityToJSON = BaseRequestAdEntityToJSON;
